export const iconFontAwesomeCommunicationSquareEnvelope = (
	<i className="fa-solid fa-square-envelope"></i>
);
